import gql from 'graphql-tag'

export default gql`
	query listOrderTypes {
		cashAssist {
			listOrderTypes {
				items {
					id
					name
					isActive
					orderType
				}
			}
		}
	}
`
